// 导入组件，组件必须声明 name
import AceIconSelector from "./src/main";
// 为组件添加 install 方法，用于按需引入
AceIconSelector.install = function (Vue) {
  Vue.component(AceIconSelector.name, AceIconSelector);
};
export default AceIconSelector;
